const taskDataModalTypes = {
    CREATE_TASK: 'CREATE_TASK',
    EDIT_TASK: 'EDIT_TASK',
};

export default taskDataModalTypes;
